import { useEffect, useState, useCallback, useMemo } from "react";
import { fetchProjects } from "../api/projectService";

export const useProjects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProjectsData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            // fetchProjectsは全ページを自動的に取得して配列を返す
            const allProjects = await fetchProjects();
            
            const validatedProjects = (allProjects || [])
                .filter(project => project && project.id && project.name)
                .map(({ id, name, ...rest }) => ({
                    id,
                    name: String(name).trim(),
                    ...rest
                }))
                .sort((a, b) => a.name.localeCompare(b.name, 'ja'));

            setProjects(validatedProjects);
        } catch (err) {
            console.error('Failed to fetch projects:', err);
            setError(err instanceof Error ? err : new Error('プロジェクトの取得に失敗しました'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProjectsData();
    }, [fetchProjectsData]);

    const memoizedProjects = useMemo(() => projects, [projects]);

    const refetch = useCallback(() => {
        fetchProjectsData();
    }, [fetchProjectsData]);

    return {
        projects: memoizedProjects,
        loading,
        error,
        refetch,
        hasProjects: projects.length > 0
    };
};